import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { TipoProducto, TipoProductoCategoria } from '../../../../interfaces/tipo-producto';
import { Validators, FormControl } from '@angular/forms';
import { TipoProductoService } from '../../../../providers/tipo-producto.service';
import { Accesorio } from '../../../../interfaces/accesorio';
import { AccesorioService } from '../../../../providers/accesorio.service';
import { MatCheckboxChange } from '@angular/material';
import { ProductoService } from '../../../../providers/producto.service';
import { TipoProductoCategoriaService } from '../../../../providers/tipo-producto-categoria.service';

@Component({
  selector: 'app-tipo-producto',
  templateUrl: './tipo-producto.component.html',
  styleUrls: ['./tipo-producto.component.scss']
})
export class TipoProductoComponent implements OnInit {
  @Input() IdTipoProducto?: number | string;
  tipoProducto: TipoProducto;
  accesorios: Accesorio[] = <Accesorio[]>[];
  tipoProductoCategoria: TipoProductoCategoria[] = <TipoProductoCategoria[]>[];
  cargandoAccesorios: boolean = false;
  cargandoCategorias: boolean = false;
  oferta: string = '';
  @Output() onTipoProductoInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  public tipoOferta: string;

  tipoProductoFormControl = new FormControl('', [
    Validators.required
  ]);

  descripcionFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private tiposCategoriasService: TipoProductoCategoriaService,
    private tipoProductoService: TipoProductoService,
    private accesorioService: AccesorioService,
    private ProductoService: ProductoService
  ) { }

  ngOnInit() {
    this.tipoOferta = this.ProductoService.getTipoOferta();
    this.oferta = this.tipoOferta == '2' ? 'servicio' : 'producto';
    this.traerTiposProducto();
    this.traerCategorias();
    this.traerAccesorios();
  }

  traerTiposProducto(): void {
    console.log('Paso');

    this.tipoProducto = new TipoProducto();

    if (this.IdTipoProducto != null) { // si recibo un id solicitar los datos
      this.formState.emit({ cargando: true });
      this.tipoProductoService.getTiposProducto(
        {
          page: null,
          pageSize: null
        },
        {
          sort: null,
          order: null
        },
        {
          IdTipoProducto: this.IdTipoProducto
        }
      ).subscribe(
        respuesta => {
          console.log('respuesta', respuesta);

          if (respuesta.estado == 1 && respuesta.data) {
            var tipoProducto = respuesta.data.tiposProducto[0];
            if (tipoProducto) {
              console.log('tipoProducto', tipoProducto);
              this.tipoProducto = new TipoProducto(
                tipoProducto.IdTipoProducto,
                tipoProducto.TipoProductoDesc,
                tipoProducto.TipoProductoObservacion,
                Object.assign([], tipoProducto.accesorios),
                new TipoProductoCategoria (
                  tipoProducto.TipoProductoCategoria.id,
                  tipoProducto.TipoProductoCategoria.descripcion,
                  ),
                  );
                  console.log(tipoProducto.TipoProductoCategoria.id);
                  console.log(tipoProducto.TipoProductoCategoria.descripcion);

              this.tipoProductoFormControl.setValue(tipoProducto.TipoProductoCategoria);

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }
  }

  traerAccesorios(): void {
    this.accesorios = [];
    this.cargandoAccesorios = true;
    this.accesorioService.getAccesorios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe( // suscribimos una nueva busqueda
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.accesorios) {
          respuesta.data.accesorios.forEach(accesorio => {
            this.accesorios.push(<Accesorio>{
              IdAccesorio: accesorio.IdAccesorio,
              descripcion: accesorio.descripcion
            });
          });
        }
      },
      () => {
        this.cargandoAccesorios = false;
      },
      () => {
        this.cargandoAccesorios = false;
      }
    );
  }

  traerCategorias(): void {
    this.tipoProductoCategoria = [];
    this.cargandoCategorias = true;
    this.tiposCategoriasService.getTipoProductoCategoria(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: '',
        tipo: this.tipoOferta
      }
    ).subscribe( // suscribimos una nueva busqueda
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.categorias) {
          respuesta.data.categorias.forEach(categoria => {
            this.tipoProductoCategoria.push(<TipoProductoCategoria>{
              IdCategoria: categoria.IdCategoria,
              id: categoria.IdCategoria,
              descripcion: categoria.descripcion,
              tipoOferta: categoria.tipoOferta,
            });
          });
        }
      },
      () => {
        this.cargandoCategorias = false;
      },
      () => {
        this.cargandoCategorias = false;
      }
    );
  }

  onAccesorioSelected(event: MatCheckboxChange, accesorio: Accesorio): void {
    if (event.checked) {
      this.tipoProducto.accesorios.push(accesorio);
    } else {
      this.tipoProducto.accesorios.forEach((accesorioItem: Accesorio, index) => {
        if (accesorioItem.IdAccesorio == accesorio.IdAccesorio) {
          this.tipoProducto.accesorios.splice(index, 1);
          return;
        }
      });
    }

    this.onInput();
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onTipoProductoInput.emit();
  }

  getTipoProducto(): TipoProducto {
    // revisar las validaciones
    if (this.tipoProductoFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.tipoProductoFormControl.markAsTouched();

      throw "Datos incorrectos";
    }
    if (this.descripcionFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.descripcionFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.tipoProducto;
  }

  compararCaracteristica(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.id == tipo2.id;
    }

    return false;
  }
}
